import { render, staticRenderFns } from "./PanoramaPagination.vue?vue&type=template&id=63bbcf13&scoped=true"
import script from "./PanoramaPagination.vue?vue&type=script&lang=js"
export * from "./PanoramaPagination.vue?vue&type=script&lang=js"
import style0 from "./PanoramaPagination.vue?vue&type=style&index=0&id=63bbcf13&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bbcf13",
  null
  
)

export default component.exports